import request from "./request"; // 引入封装好的 axios 实例

const httpRequest = {
    /**
     * methods: 请求
     * @param url 请求地址
     * @param params 请求参数
     */
    get(url, params) {
        const config = { method: "get", url: url };

        if (params) config.params = params;

        return request(config);
    },

    post(url, params) {
        const config = { method: "post", url: url };

        if (params) config.data = params;

        return request(config);
    },

    put(url, params) {
        const config = { method: "put", url: url };

        if (params) config.data = params;

        return request(config);
    },

    delete(url, params) {
        const config = { method: "delete", url: url };

        if (params) config.params = params;

        return request(config);
    }
};

export default httpRequest;



// WEBPACK FOOTER //
// ./src/assets/js/request/httpRequest.js